import * as React from 'react';
import { Image } from '@cian/ui-kit';

export interface IThumbnailProps {
  src: string;
}

export const Thumbnail: React.VFC<IThumbnailProps> = ({ src }) => {
  return <Image src={src} borderRadius={0} objectFit="cover" data-testid="Thumbnail" />;
};
